import { render } from "./PenggunaView.vue?vue&type=template&id=488105d8"
import script from "./PenggunaView.vue?vue&type=script&lang=js"
export * from "./PenggunaView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__